import { Col, Row } from "react-bootstrap";
import PersonReviewedIndicatorsList from "./PersonReviewedIndicatorsList";
import { useTranslation } from "react-i18next";
import "./PersonReviewed.css";

function PersonReviewed({ id, name, totalScore, indicators }) {
  const { t } = useTranslation();

  const selectSpanClass = (score) => {
    if (score >= 90) {
      return "person-reviewed-score-green";
    } else if (score < 90 && score >= 70) {
      return "person-reviewed-score-yellow";
    } else if (score < 70 && score >= 0) {
      return "person-reviewed-score-red";
    }
  };

  return (
    <Col key={id} className="person-reviewed-card mb-4">
      <Row className="justify-content-center align-items-center mb-4">
        <Col>
          <h5 className="person-reviewed-name">{name}</h5>
        </Col>
        <Col className="right person-reviewed-total-score">
          <span
            className={isNaN(totalScore) ? "" : selectSpanClass(totalScore)}
          >
            {isNaN(totalScore) || totalScore === null
              ? "N/A"
              : totalScore.toFixed(2)}
          </span>
        </Col>
      </Row>
      {indicators.length > 0 ? (
        <Row>
          <PersonReviewedIndicatorsList indicators={indicators} />
        </Row>
      ) : (
        <></>
      )}
    </Col>
  );
}

export default PersonReviewed;
